// オブジェクトの複数のキーの存在と中身を確認する関数
const areKeysPresent = (obj, keys) => {
    return keys.every(
        (key) =>
            obj.hasOwnProperty(key) &&
            obj[key] !== null &&
            obj[key] !== undefined &&
            obj[key] !== ""
    );
};

// 存在しないか空のキーを見つける関数
const findMissingOrEmptyKeys = (obj, keys) => {
    return keys.filter(
        (key) =>
            !obj.hasOwnProperty(key) ||
            obj[key] === null ||
            obj[key] === undefined ||
            obj[key] === ""
    );
};

/**
 * 指定されたnameとplannameに基づいてプラン情報を取得する関数
 *
 * @param data - プラン情報を含む配列
 * @param name - 取得したいプランの名前（例: "AT", "MT", "準中型"）
 * @param planname - 取得したいプランの種類（例: "チャレンジ", "スタンダード", "デラックス", "特急"）
 * @returns 指定されたプランの情報、見つからない場合はundefined
 *
 * @example
 * const planData = [
 *   {
 *     name: "AT",
 *     type: [
 *       { planname: "チャレンジ", days: "21", price: "¥300,000" },
 *       // ...他のプラン
 *     ]
 *   },
 *   // ...他の免許タイプ
 * ];
 *
 * const result = getPlanInfo(planData, "AT", "チャレンジ");
 * console.log(result); // { planname: "チャレンジ", days: "21", price: "¥300,000" }
 */
const getPlanInfo = (data, name, planname) => {
    const licenseType = data.find((item) => item.name === name);
    if (!licenseType) return undefined;

    return licenseType.type.find((plan) => plan.planname === planname);
};

// 日付をフォーマットする関数だよ
const formatDate = (date) => {
    return `${date.getMonth() + 1}月${date.getDate()}日`;
};

/**
 * 開始日から指定した日数後までの期間を「○月○日〜○月○日」の形式で返すよ！
 * @param {string} startDate - 開始日 (YYYY-MM-DD形式)
 * @param {number} days - 追加する日数
 * @returns {string} フォーマットされた日付範囲
 *
 * @example
 * // 使い方はこんな感じだよ！
 * console.log(getDateRange('2024-08-16', 5));
 * // 出力: '8月16日〜8月21日'
 */
const getDateRange = (startDate, days) => {
    // 開始日をDate型に変換するよ
    const start = new Date(startDate);

    // 終了日を計算するよ（開始日に日数を足すの）
    const end = new Date(start);
    end.setDate(end.getDate() + days);

    // フォーマットした日付範囲を返すよ
    return `${formatDate(start)}〜${formatDate(end)}`;
};

/**
 * 指定された日付が特定の範囲内にあるかチェックする関数だよ！
 * @param {string} dateValue - チェックしたい日付（'YYYY-MM-DD'形式）
 * @param {Object} range - チェックする日付の範囲
 * @param {string} range.min - 範囲の開始日（'YYYY-MM-DD'形式）
 * @param {string} range.max - 範囲の終了日（'YYYY-MM-DD'形式）
 * @returns {boolean} 日付が範囲内ならtrue、そうでないならfalseを返すよ
 *
 * @example
 * const result = isDateInRange('2024-12-25', { min: '2024-11-01', max: '2025-03-31' });
 * console.log(result); // true
 */
const isDateInRange = (dateValue, range) => {
    const date = new Date(dateValue);
    const minDate = new Date(range.min);
    const maxDate = new Date(range.max);

    return date >= minDate && date <= maxDate;
};

if (document.body.classList.contains("page-simulator")) {
    const backbtns = document.querySelectorAll(
        ".sim__cntInnerSeleTabsTab .back"
    );
    const tabs = document.querySelectorAll(".sim__cntInnerSeleTabsTab");
    const progs = document.querySelectorAll(
        ".sim__cntInner>.sim__cntInnerSeleProg>.sim__cntInnerSeleProgCell"
    );
    const spprogs = document.querySelectorAll(
        ".sim__cntInnerSele>.sim__cntInnerSeleProg>.sim__cntInnerSeleProgCell"
    );
    const sele = document.querySelector(".sim__cntInnerSele");
    const res = document.querySelector(".sim__cntInnerSeleRes");

    const jsonTemp = JSON.parse(
        document.querySelector("template.data").innerHTML
    );
    const jsonStartend = JSON.parse(
        document.querySelector("template.startend").innerHTML
    );
    console.log(jsonTemp);

    let tabProgress = -1;
    const ans = {};

    const setTabProgress = (num) => {
        tabProgress = num;
        toggleOn();
        // console.log(ans);
    };

    const ansOnChange = () => {
        if (ans.type) {
            const plantab = document.querySelector(
                ".sim__cntInnerSeleTabsTab.plan"
            );

            const plantabBtns = plantab.querySelectorAll("button");

            const target = jsonTemp.find((data) => data.name === ans.type);
            // console.log(target);

            if (target) {
                plantabBtns.forEach((btn) => {
                    const isThere = target.type.find(
                        (ty) => ty.planname === btn.dataset.value
                    );

                    const isCrctDate =
                        isThere && ans["date"]
                            ? isThere.dependsOnDay.enabled
                                ? isDateInRange(ans["date"], {
                                      min: isThere.dependsOnDay.start,
                                      max: isThere.dependsOnDay.end,
                                  })
                                : true
                            : false;

                    if (isThere && isCrctDate) {
                        btn.classList.remove("is-disabled");
                    } else {
                        btn.classList.add("is-disabled");
                    }
                });
            }
        }
    };

    const whenFinished = () => {
        if (areKeysPresent(ans, ["plan", "date", "type"])) {
            const startDateElm = res.querySelector("p.startdate");
            const dateElm = res.querySelector("p.date");
            const priceElm = res.querySelector("span.priceval");

            const selectedPlan = getPlanInfo(
                jsonTemp,
                ans["type"],
                ans["plan"]
            );

            if (selectedPlan) {
                const startDate = new Date(ans["date"]);
                startDateElm.innerHTML = formatDate(startDate);
                dateElm.innerHTML = getDateRange(
                    ans["date"],
                    parseInt(selectedPlan.dpm[startDate.getMonth()].days)
                );
                priceElm.innerHTML = selectedPlan.price;
            } else {
                setTabProgress(0);
            }
        } else {
            setTabProgress(0);
        }
    };

    const toggleOn = () => {
        [...tabs, ...progs, ...spprogs].forEach((elm) => {
            elm.classList.remove("is-crnt");
        });

        if (tabProgress >= 0 && tabProgress < tabs.length) {
            tabs[tabProgress].classList.add("is-crnt");

            for (let n = 0; n <= tabProgress; n++) {
                progs[n].classList.add("is-crnt");
                spprogs[n].classList.add("is-crnt");
            }
            sele.classList.remove("is-selected");
        } else {
            sele.classList.add("is-selected");
            whenFinished();
        }
    };

    setTabProgress(0);

    backbtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            setTabProgress(tabProgress - 1);
        });
    });

    tabs.forEach((tab) => {
        const btns = tab.querySelectorAll("button");
        const divBtns = tab.querySelectorAll("div.btn");
        const dateInput = tab.querySelector(
            ".sim__cntInnerSeleTabsTabInnerDateInput input"
        );

        btns.forEach((btn) => {
            btn.addEventListener("click", () => {
                ans[btn.dataset.key] = btn.dataset.value;
                ansOnChange();
                setTabProgress(tabProgress + 1);
            });
        });

        divBtns.forEach((btn) => {
            if (btn.classList.contains("picker")) {
                btn.addEventListener("click", () => {
                    try {
                        dateInput.focus();
                        dateInput.showPicker();
                    } catch (error) {
                        console.warm(error);
                    }
                });
            } else if (btn.classList.contains("date")) {
                btn.addEventListener("click", () => {
                    if (dateInput.value) {
                        if (isDateInRange(dateInput.value, jsonStartend)) {
                        } else {
                            dateInput.value = "";
                            alert(
                                `${
                                    new Date(jsonStartend.min).getMonth() + 1
                                }月〜${
                                    new Date(jsonStartend.max).getMonth() + 1
                                }月の間で選択してください。`
                            );
                            return;
                        }
                        ans[dateInput.name] = dateInput.value;
                        ansOnChange();
                        setTabProgress(tabProgress + 1);
                    } else {
                        try {
                            dateInput.focus();
                            dateInput.showPicker();
                        } catch (error) {
                            console.log(error);
                        }
                    }
                });
            }
        });
    });

    const progOnClick = (prog, index) => {
        prog.addEventListener("click", () => {
            if (index < tabProgress) {
                setTabProgress(index);
            }
        });
    };

    progs.forEach(progOnClick);
    spprogs.forEach(progOnClick);

    {
        // const inputdate = sele.querySelector(`input[type="date"]`);
        // const today = new Date();
        // const yyyy = today.getFullYear();
        // const mm = String(today.getMonth() + 1).padStart(2, "0");
        // const dd = String(today.getDate()).padStart(2, "0");
        // const formattedDate = `${yyyy}-${mm}-${dd}`;
        // inputdate.value = formattedDate;
    }

    {
        const resh2 = res.querySelector(".btn.btf");
        resh2.addEventListener("click", () => {
            setTabProgress(0);
        });
    }
}
